<div class="" *ngFor="let item of fancyData; let i=index;trackBy:trackByIndex;">
  <div class="fancy_rows" *ngIf="isInclude(tabVal, item?.sort_priority)">
    <div class="row mx-0 align-items-center" *ngIf="isFancy ? item.fancy_type != 'LINE' : item.fancy_type == 'LINE'">
          <div class="col-lg-6 col-md-6 col-8 px-0">
              <a href="javascript:void(0);" class="add-pin ml-1" *ngIf="isLogin() && !multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')"><i class="mdi mdi-pin"></i></a>
              <a href="javascript:void(0);" class="add-pin ml-1" *ngIf="isLogin() && multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')"><i class="mdi mdi-pin-off"></i></a>
              <span class="marketevent">
                  {{item.name}}
                  <b class="d-block" (click)="fancyRunPosition(bookModal, item)" *ngIf="expo[item?.market_id] && expo[item?.market_id][item?.selection_id]" [ngClass]="expo[item?.market_id][item?.selection_id]?.expose > 0 ? 'profit' : 'loss'" (click)="fancyRunPosition(bookModal, item)">{{expo[item?.market_id][item?.selection_id]?.expose}}</b>
              </span>
              <button class="mobile-tooltip" data-toggle="tooltip" data-placement="top" title="min:{{kFormatter(item?.min_bet)}} | max:{{kFormatter(item?.max_bet)}}">
                  <i class="mdi mdi-information"></i>
              </button>
              <a href="javascript:void(0);" class="laddarmod" *ngIf="expo[item?.market_id] && expo[item?.market_id][item?.selection_id]" (click)="fancyRunPosition(bookModal, item)">
                <svg height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 199.22 199.22" xml:space="preserve">
                    <g>
                        <path style="fill:#010002;" d="M132.314,0v34.765h-65.4V0H47.821v199.22h19.093v-46.253h65.4v46.253H151.4V0H132.314z
                             M62.505,194.818H52.23V4.398h10.275V194.818z M132.314,148.565h-65.4v-33.774h65.4V148.565z M132.314,110.379h-65.4V74.408h65.4
                            V110.379z M132.314,70.002h-65.4V39.174h65.4V70.002z M146.994,194.818h-10.278V4.398h10.278V194.818z"/>
                    </g>
                </svg>
              </a>
          </div>
          <div class="col-lg-6 col-md-6 col-4 px-0">
              <div class="btn-group">
                  <button class="ex-bl"></button>
                  <button class="ex-bl"></button>
                  
                  <div class="fancy_odds">
                    <div>
                        <!-- 1st odds -->
                        <button class="lay {{odds[item?.market_id]?.lKey}}" (click)="openBetPlace(item, odds[item?.market_id], '', odds[item?.market_id], '', 'l3', 'fancy')">
                            {{odds[item?.market_id]?.lay_price ? odds[item?.market_id]?.lay_price : '-'}}
                            <small>{{odds[item?.market_id]?.lay_rate ? odds[item?.market_id]?.lay_rate : '-'}}</small>
                        </button>
                        <button class="back {{odds[item?.market_id]?.bKey}}" (click)="openBetPlace(item, odds[item?.market_id], '', odds[item?.market_id], '', 'b1', 'fancy')">
                            {{odds[item?.market_id]?.back_price?odds[item?.market_id]?.back_price : '-'}}
                            <small>{{odds[item?.market_id]?.back_rate ? odds[item?.market_id]?.back_rate : '-'}}</small>
                        </button>
                    </div>
                    <div>
                        <!-- 2nd odds -->
                        <button class="lay {{odds[item?.market_id]?.lKey1}}" *ngIf="odds[item?.market_id]?.active_rate1 == 1" (click)="openBetPlace(item, odds[item?.market_id], '1', odds[item?.market_id], '1', 'l2', 'fancy')">
                            {{odds[item?.market_id]?.lay1_price ? odds[item?.market_id]?.lay1_price : '-'}}
                            <small>{{odds[item?.market_id]?.lay1_rate ? odds[item?.market_id]?.lay1_rate : '-'}}</small>
                        </button>
                        <button class="back {{odds[item?.market_id]?.bKey1}}" *ngIf="odds[item?.market_id]?.active_rate1 == 1" (click)="openBetPlace(item, odds[item?.market_id], '1', odds[item?.market_id], '1', 'b2', 'fancy')">
                            {{odds[item?.market_id]?.back1_price ? odds[item?.market_id]?.back1_price : '-'}}
                            <small>{{odds[item?.market_id]?.back1_rate ? odds[item?.market_id]?.back1_rate : '-'}}</small>
                        </button>
                    </div>
                    <div>
                        <!-- 3rd odds -->
                        <button class="lay {{odds[item?.market_id]?.lKey2}}" *ngIf="odds[item?.market_id]?.active_rate2 == 1" (click)="openBetPlace(item, odds[item?.market_id], '2', odds[item?.market_id], '2', 'l1', 'fancy')">
                            {{odds[item?.market_id]?.lay2_price ? odds[item?.market_id]?.lay2_price : '-'}}
                            <small>{{odds[item?.market_id]?.lay2_rate ? odds[item?.market_id]?.lay2_rate : '-'}}</small>
                        </button>
                        <button class="back {{odds[item?.market_id]?.bKey2}}" *ngIf="odds[item?.market_id]?.active_rate2 == 1" (click)="openBetPlace(item, odds[item?.market_id], '2', odds[item?.market_id], '2', 'b3', 'fancy')">
                            {{odds[item?.market_id]?.back2_price ? odds[item?.market_id]?.back2_price : '-'}}
                            <small>{{odds[item?.market_id]?.back2_rate ? odds[item?.market_id]?.back2_rate : '-'}}</small>
                        </button>
                    </div>
                  </div>
                  
                  <div class="suspended" *ngIf="odds[item?.market_id]?.suspended == 1">SUSPENDED</div>
                  <div class="suspended" *ngIf="odds[item?.market_id]?.suspended == 0 && odds[item?.market_id]?.ball_running == 1">
                      BALL RUNNING
                  </div>
                  <div class="suspended" *ngIf="odds[item?.market_id] && odds[item?.market_id]?.bet_allow == 0"></div>
                  <button class="two-odds-min-max">
                      <span class="d-block">Min: {{kFormatter(item?.min_bet)}}</span> 
                      <span class="d-block">Max: {{kFormatter(item?.max_bet)}}</span>
                  </button>
              </div>
              <!-- <div class="btn-group">
                <button class="ex-bl">
                </button>
                <button class="ex-bl">
                </button>
                <button class="back">
                    1.79
                    <small>135.0k</small>
                </button>
                <button class="lay">
                    1.79
                    <small>135.0k</small>
                </button>
                <div class="suspended">suspended</div>
                <button class="two-odds-min-max">
                    <span class="d-block">Max: 100K</span>
                    <span class="d-block">MKT: 1000K</span>
                </button>
            </div> -->
          </div>

          <!-- betslip (d-sm-none - add this class if below betslip only for mobile view) -->
          <div class="col-lg-12 col-md-12 col-12 px-0" *ngIf="betSlipData?.market_id == item?.market_id && betSlipData?.selection_id == item?.selection_id">
              <app-bet-slip [data]="betSlipData" (closeBet)="closeBet.emit($event)" (updateData)="updateData.emit($event)"
                  (changeExpo)="changeExpo.emit($event)">
              </app-bet-slip>
          </div>
          <!-- betslip -->
          
    </div>
    <!-- message -->
    <div class="row mx-0 align-items-center" *ngIf="(isFancy ? item.fancy_type != 'LINE' : item.fancy_type == 'LINE') && odds[item?.market_id]?.message != null && odds[item?.market_id]?.message != ''">
      <div class="col-12 text-right">
          <span class="msgs">
              <i class="mdi mdi-email mr-1"></i>
              {{odds[item?.market_id]?.message}}
          </span>
      </div>
    </div>
    <!-- message -->
    
  </div>
</div>

<ng-template #bookModal>
  <div class="modal-header">
        <h4 class="modal-title mt-0">{{book_name}}</h4>
        <button type="button" class="close" (click)="modalRef?.hide()">×</button>
    </div>
    <div class="modal-body">
        <div class="table-responsive">
            <table class="table mb-0">
                <thead>
                    <th>Run</th>
                    <th>Amount</th>
                </thead>
                <tbody>
                    <tr [ngClass]="(item.expose >= 0) ? 'back' : 'lay'" *ngFor="let item of fancyRun;trackBy:trackByIndex;">
                        <td>{{item.run}}</td>
                        <td class="" [ngClass]="(item.expose >= 0) ? 'profit' : 'loss'">{{item.expose}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row w-100">
            <div class="col-12 text-center">
                <button type="button" class="btn btn-outline-danger" (click)="modalRef?.hide()">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>